import React, { memo } from 'react';
// import _ from 'lodash';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

import TableDetails from './TableDetails';

const styles = StyleSheet.create({
  display__flex: {
    marginTop: 14,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
  },
  main__heading: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: '600',
    width: '170px',
    flexWrap: 'wrap',
  },
  mini__heading__first: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  mini__heading: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
    marginLeft: 10,
  },
  mini__heading__inner: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  display__flex__row: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  main__status__btn: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '500',
  },
  btn__styling: {
    borderRadius: 100,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 15,
    paddingRight: 15,
    marginLeft: 10,
    color: '#2CB46A',
    backgroundColor: 'rgba(49, 194, 116, .3)',
  },
  btn__styling__danger: {
    borderRadius: 100,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 15,
    paddingRight: 15,
    marginLeft: 10,
    color: '#FF3636',
    backgroundColor: '#FFD7D7',
  },
  btn__styling__no__action: {
    borderRadius: 100,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 15,
    paddingRight: 15,
    marginLeft: 10,
    color: '#263238',
    backgroundColor: '#E1E4E7',
  },
});

const Table = ({ data }) => {
  const { jobs = [] } = data || '';
  return (
    <>
      {jobs?.map((job, i) => {
        const { items = [] } = job?.extrasWithJob || '';

        return (
          <>
            <View style={styles.display__flex} key={i++}>
              <View style={styles.display__flex__row}>
                <Text style={styles.main__heading}>
                  {i + 1} of {jobs?.length}
                  {job?.title ? '. ' + job.title : ''}
                </Text>
                <View
                  style={
                    job?.authorizationStatus?.toLowerCase() === 'approved'
                      ? styles.btn__styling
                      : job?.authorizationStatus?.toLowerCase() === 'declined'
                      ? styles.btn__styling__danger
                      : styles.btn__styling__no__action
                  }
                >
                  <Text style={styles.main__status__btn}>
                    {job?.authorizationStatus}
                  </Text>
                </View>
              </View>

              <View style={styles.display__flex__row}>
                <Text style={styles.mini__heading__first}>
                  Technician:{' '}
                  <Text style={styles.mini__heading__inner}>
                    {job?.co_user?.name}
                  </Text>
                </Text>
                <Text style={styles.mini__heading}>
                  Reference:{' '}
                  <Text style={styles.mini__heading__inner}>
                    {job?.ro_concerns_recommendation?.issueType ===
                    'customerConcern'
                      ? 'Customer Concern'
                      : 'Tech Recommendation'}
                  </Text>
                </Text>
              </View>
            </View>

            <TableDetails items={items} notes={job?.notes || ''} />
          </>
        );
      })}
    </>
  );
};
export default memo(Table);
